import {Input, InputProps} from '@/shadcn_components/ui/input';
import {useState} from 'react';
import {Table} from '@tanstack/react-table';
import {Search} from 'lucide-react';
import {cn} from '@/lib/tailwind-utils';

export type DataTableGlobalFilterProps<TData = any> = {
  label?: string;
  table: Table<TData>;
} & Omit<InputProps, 'source' | 'ref'>;

export const DataTableGlobalFilter = (props: DataTableGlobalFilterProps) => {
  const {label, table, className, ...remainProps} = props;
  const [value, setValue] = useState('');

  function onChangeInput(e) {
    const value = e.target.value;
    setValue(value);
    table.setGlobalFilter(value);
  }

  return (
    <div className="w-full relative flex items-center p-0">
      <Search className="absolute left-2 top-0 h-full w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder={label || 'Tìm kiếm ...'}
        className={cn('h-8 w-[150px] lg:w-[250px] pl-8', className)}
        value={value}
        onChange={onChangeInput}
        {...remainProps}
      />
    </div>
  );
};
